import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9a9574de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login d-f justify-c align-c" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {"color":"#fff","font-size":"18px"},
  class: "m-b-20"
}, "欢迎登录OASIS", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Log in ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_LockOutlined = _resolveComponent("LockOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, {
      model: _ctx.formState,
      onFinish: _ctx.handleFinish
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        (_ctx.visible)
          ? (_openBlock(), _createBlock(_component_a_alert, {
              key: 0,
              message: "账号密码错误,请输入后重试",
              type: "error",
              class: "m-b-20"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: _ctx.formState.user,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.user) = $event)),
              style: {"width":"300px","height":"40px"},
              placeholder: "Username"
            }, {
              prefix: _withCtx(() => [
                _createVNode(_component_UserOutlined, { style: {"color":"rgba(0, 0, 0, 0.25)"} })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: _ctx.formState.password,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.password) = $event)),
              style: {"width":"300px","height":"40px"},
              type: "password",
              placeholder: "Password"
            }, {
              prefix: _withCtx(() => [
                _createVNode(_component_LockOutlined, { style: {"color":"rgba(0, 0, 0, 0.25)"} })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          block: "",
          style: {"width":"100%","height":"40px"},
          type: "primary",
          "html-type": "submit",
          disabled: _ctx.formState.user === '' || _ctx.formState.password === ''
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    }, 8, ["model", "onFinish"])
  ]))
}